import { render, staticRenderFns } from "./admin-layout.vue?vue&type=template&id=4dddabbb&scoped=true"
import script from "./admin-layout.vue?vue&type=script&lang=ts"
export * from "./admin-layout.vue?vue&type=script&lang=ts"
import style0 from "./admin-layout.vue?vue&type=style&index=0&id=4dddabbb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dddabbb",
  null
  
)

export default component.exports